var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruiters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7803 17.7803C17.634 17.9265 17.442 18 17.25 18C17.058 18 16.866 17.9265 16.7198 17.7803L14.8148 15.8752C14.2215 16.2682 13.5128 16.5 12.75 16.5C10.6823 16.5 9 14.8177 9 12.75C9 10.6823 10.6823 9 12.75 9C14.8178 9 16.5 10.6823 16.5 12.75C16.5 13.5127 16.2683 14.2215 15.8753 14.8148L17.7803 16.7197C18.0735 17.013 18.0735 17.487 17.7803 17.7803ZM6.75 9C9.23175 9 11.25 6.98175 11.25 4.5C11.25 2.01825 9.23175 0 6.75 0C4.26825 0 2.25 2.01825 2.25 4.5C2.25 6.98175 4.26825 9 6.75 9ZM7.5 12.75C7.5 11.9925 7.6635 11.2748 7.95225 10.6245C7.56075 10.5518 7.1625 10.5 6.75 10.5C3.03225 10.5 0.00675126 13.521 1.2644e-06 17.2372C-0.000748736 17.655 0.332251 18 0.750001 18H12.75C9.8505 18 7.5 15.6495 7.5 12.75Z",
    fill: "url(#paint0_linear_192_400)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_400",
    x1: 9.0001,
    y1: 0,
    x2: 9.0001,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiters);
export default __webpack_public_path__ + "static/media/recruiters.7c883a526bede1feb63b684cd948a34f.svg";
export { ForwardRef as ReactComponent };